export default __webpack_public_path__ + "static/media/Stacy-White.4ae64079.jpg";